<template lang="pug">
transition(name="slide-up" appear)
  .inventory-selection-actions(v-if="show")
    .d-flex.align-center
      .yz-regular-body-sm.neutral700--text {{ selectedItems.length }} items selected
      v-spacer
      .d-flex.align-center.gap-2
        // ON HOLD UNTIL FURTHER NOTICE
        //yz-btn(label="Assign to branch & warehouse" size="lg" prepend-icon="$yzi-repeat-01" @click="$emit('assign')")
        yz-btn(label="Request for quotation" size="lg" prepend-icon="$yzi-file-05" @click="showRfqDialog = true")
        yz-btn(label="Create purchase order" size="lg" prepend-icon="$yzi-file-05" @click="showPoDialog = true")

    select-document-type-dialog(v-model="showRfqDialog" title="Request for quotation (RFQ)" description="Draft from inventory & send request to supplier or origin" :options="rfqOptions" @confirm="onConfirmRfq")
    select-document-type-dialog(v-model="showPoDialog" title="Purchase order" description="Manage payments, adjust rates & auto-update received stock" :options="poOptions" @confirm="onConfirmPo")
</template>

<script>
import SelectDocumentTypeDialog from './SelectDocumentTypeDialog.vue'

export default {
  components: { SelectDocumentTypeDialog },
  props: {
    selectedItems: { type: Array, default: () => [] },
    show: { type: Boolean, default: false }
  },
  data() {
    return {
      showRfqDialog: false,
      showPoDialog: false,
      rfqOptions: [
        { value: 'supplier', label: 'Request from supplier' },
        { value: 'warehouse', label: 'Request from warehouse' },
        { value: 'branch', label: 'Request from branch' }
      ],
      poOptions: [
        { value: 'supplier', label: 'Order from supplier' },
        { value: 'warehouse', label: 'Order from warehouse (Multibranch HQ)' },
        { value: 'branch', label: 'Order from branch' }
      ]
    }
  },
  methods: {
    onConfirmRfq(type) {
      this.$emit('request-quotation', type)
    },
    onConfirmPo(type) {
      this.$emit('create-po', type)
    }
  }
}
</script>

<style lang="scss" scoped>
.inventory-selection-actions {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  background-color: white;
  padding: 12px 16px;
  box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.2);
  z-index: 100;
  border-radius: 10px;
  max-width: 900px;
  margin: 0 auto;
  border-bottom: 3px solid #000;
}

.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
